module.exports = __webpack_public_path__ + "img/ambi_logo.a33438fb.svg";